import { useMe } from '../../api/useMe';

export default function AgentStatusBar() {
  const { data: me } = useMe();
  const parsedCount = me?.parse_count ?? me?.usage?.parsed_count ?? 0;
  const quotaLimit = me?.usage?.quota_limit;
  const explicitRemaining =
    me?.usage?.remaining_quota ??
    me?.usage?.parses_left ??
    me?.usage?.parses_remaining ??
    me?.usage?.remaining;

  let parsesLeftDisplay: string;
  if (explicitRemaining !== undefined && explicitRemaining !== null) {
    parsesLeftDisplay = `${explicitRemaining}`;
  } else if (quotaLimit !== undefined && quotaLimit !== null) {
    parsesLeftDisplay = `${Math.max(0, quotaLimit - parsedCount)}`;
  } else {
    parsesLeftDisplay = 'Unlimited';
  }

  return (
    <div className="flex items-center justify-between pb-5 border-b border-brand-line dark:border-strokedark mb-6">
      {/* Bot Identity */}
      <div className="flex items-center gap-3.5">
        {/* Agent Avatar with Digital Green Gradient */}
        <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-gradient-to-br from-[#12b98a] to-[#16EA9E] text-brand-navy shadow-sm">
          <svg
            className="w-6 h-6 fill-current"
            viewBox="0 0 24 24"
          >
            <path d="M12 2a2 2 0 012 2c0 .74-.4 1.38-1 1.72V7h4a3 3 0 013 3v8a3 3 0 01-3 3H7a3 3 0 01-3-3v-8a3 3 0 013-3h4V5.72A2 2 0 0110 4a2 2 0 012-2zm-4 8a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm8 0a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm-6 6h4a1 1 0 100-2h-4a1 1 0 100 2z" />
          </svg>
        </div>

        <div>
          <div className="flex items-center gap-2">
            <h1 className="text-[17px] font-bold text-brand-navy dark:text-white tracking-tight">
              Invoice AI Agent
            </h1>
            <span className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[10px] font-mono font-semibold bg-emerald-50 text-emerald-700 dark:bg-emerald-950/40 dark:text-emerald-400 border border-emerald-200 dark:border-emerald-800">
              <span className="w-1.5 h-1.5 rounded-full bg-brand-green animate-pulse" />
              ONLINE
            </span>
          </div>
          <div className="text-[10px] font-mono tracking-wider text-brand-soft dark:text-bodydark2 uppercase mt-0.5">
            ACTIVE · MODEL INVOICEPARSE AI V1.5
          </div>
        </div>
      </div>

      {/* Parse Balance Pill */}
      <div className="flex items-center gap-1.5 bg-brand-blue-tint border border-brand-vib/15 dark:bg-strokedark/50 dark:border-strokedark rounded-full px-3.5 py-1.5 font-mono text-[11px] text-brand-muted dark:text-bodydark">
        <svg
          className="w-3.5 h-3.5 text-brand-vib fill-current"
          viewBox="0 0 24 24"
        >
          <path d="M7 2v11h3v9l7-12h-4l4-8z" />
        </svg>
        <span className="font-semibold text-brand-navy dark:text-white">
          {parsesLeftDisplay}
        </span>
        {quotaLimit !== undefined && quotaLimit !== null && (
          <span className="text-brand-soft dark:text-bodydark2">
            /{quotaLimit}
          </span>
        )}
        <span className="hidden sm:inline">left</span>
      </div>
    </div>
  );
}
